import {createFileRoute} from '@tanstack/react-router';

import {NewJobPage} from '@/modules/jobs/pages/NewJobPage';

export const Route = createFileRoute('/_authenticated/jobs/new')({
  component: NewJobPage,
});
